import React from "react";
import { useAppDispatch } from "../../../../../../app/hooks";
import { Button } from "@mui/material";
import { Block } from "@mui/icons-material";
import { toggleIncidentRejectCommentModal } from "../../../../../../app/slices/VarianceModuleSlice";
import { IncidentRejectCommentDialog } from "../../comments/IncidentRejectCommentDialog";

type ownProps = {
  setNotify: Function;
  setMessage: Function;
};

function VarianceRejectBtn(props: ownProps) {
  const dispatch = useAppDispatch();

  const handleReject = () => {
    dispatch(toggleIncidentRejectCommentModal());
  };

  return (
    <React.Fragment>
      <Button
        variant="outlined"
        color="error"
        startIcon={<Block />}
        onClick={handleReject}
      >
        Reject
      </Button>
      <IncidentRejectCommentDialog setNotify={props.setNotify} setMessage={props.setMessage} />
    </React.Fragment>
  );
}

export { VarianceRejectBtn };
